import { useState } from "react";
import { observer } from "mobx-react-lite";
import { notifyError } from "../../../../components/Errors/ErrorAlert";
import { createAlarmCodeRule } from "../../../../core/api/responsecenters/alarmcoderules";
import { ResponseCenterAlarmCodeRuleDetails } from "../../../../core/api/responsecenters/types";
import useTranslations from "../../../../core/i18n/useTranslations";
import useUser from "../../../../core/user/useUser";
import { notify } from "../../../../ui-lib/components/Alerts/Toast";
import { AlarmCodeRuleForm } from "./AlarmCodeRuleForm";
import Button from "../../../../ui-lib/components/Button/Button";

const CreateAlarmCodeRuleModal = ({
  responseCenterId,
  onAdd,
}: {
  responseCenterId: string | number;
  onAdd: () => void;
}) => {
  const t = useTranslations();
  const { authenticatedRequest } = useUser();

  const [createRuleModalOpen, setCreateRuleModalOpen] = useState(false);

  const labels = {
    title: t("AlarmReceptions:alarm_handling_alarm_code_rule_add"),
    description: t(
      "AlarmReceptions:alarm_handling_alarm_code_rule_add_description"
    ),
    submit: t("AlarmReceptions:alarm_handling_alarm_code_rule_add"),
  };

  const onSubmit = async (values: ResponseCenterAlarmCodeRuleDetails) => {
    try {
      await createAlarmCodeRule(responseCenterId, values, authenticatedRequest);

      notify({
        message: t("AlarmReceptions:alarm_handling_alarm_codes_add_success"),
      });
      onAdd();
      setCreateRuleModalOpen(false);
    } catch (error: any) {
      notifyError({
        error,
        t,
      });
    }
  };

  return (
    <>
      <Button
        size="small"
        variant="secondary"
        text={t("AlarmReceptions:alarm_handling_alarm_code_rules_add")}
        onClick={() => setCreateRuleModalOpen(true)}
      />
      {createRuleModalOpen && (
        <AlarmCodeRuleForm
          isOpen={createRuleModalOpen}
          labels={labels}
          onSubmit={onSubmit}
          onClose={() => setCreateRuleModalOpen(false)}
        />
      )}
    </>
  );
};

export default observer(CreateAlarmCodeRuleModal);
